import * as Sentry from '@sentry/react';

export function initSentry() {
  if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_ENV || 'production',

      // Differentiate from mobile app in Sentry dashboard
      initialScope: {
        tags: {
          app: 'landing-page', // Filter: app:landing-page
          platform: 'web',
        },
      },

      // Performance monitoring (10% sample rate)
      tracesSampleRate: 0.1,

      // Session replay for debugging
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
    });
  }
}

// Error boundary wrapper
export const SentryErrorBoundary = Sentry.ErrorBoundary;

// Manual error capture for try-catch blocks
export function captureException(error: unknown, context?: Record<string, unknown>) {
  if (import.meta.env.PROD) {
    Sentry.captureException(error, { extra: context });
  } else {
    // In development, log to console for visibility
    console.error('[Sentry would capture]:', error, context);
  }
}
